<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="materia-costo" titulo="Materia / Materia Costo" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate (ngSubmit)="enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">
                        <div class="level-right">
                            <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                                <span class="icon fa-2x">
                                  <i class="icon-back"> </i>
                                </span>
                                <span class="tooltiptext">Regresar</span>
                              </a>
                              <button class="navbar-item  tooltip" type="button" [ngClass]="{'is-loading': cargando}" [disabled]="cargando"
                              (click)="ctrl.abrirModal('confirmarCalificacion')">
                              <span class="icon fa-2x has-text-success">
                                <i class="icon-diskette"> </i>
                              </span>
                              <span class="tooltiptext">Guardar</span>
                            </button>
                        </div>
                        <!-- Opciones  -->
                        <!-- <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones> -->
                    </div>
                </section>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;">
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos"
                        (click)="ctrl.cargarCatalogo('carreras_planes','carrera-plan', '', 'cargando'); "></a>
                    <!-- <a id="CaragarLogos" (click)="ctrl.cargarCatalogo('logos64', 'logos64?carreras_planes_id='+carrera_plan.id, 'logo64');"></a>
                    <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a> -->
                    <!-- <a id="filtrar" (click)="filtrar(ctrl.materias);"></a> -->

                    <div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
                        <div class="bloquear-azul">
              
                        </div>
                        <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
                          <span class="icon">
                            <i class="icon-worldwide fa-spin"></i>
                          </span> &nbsp;
                          <span>Cargando...</span>
                        </span>
                      </div>

                    <!-- <div class="column is-6">
                        <label class="label">Materia:</label>
                        <div class="control has-icons-left has-icons-right">
                            <div class="select"> -->
                    <!-- <select class="select" name="materias_id" formControlName="materias_id">
                                    <option *ngFor="let val of materias" value="{{val.id}}">{{ val.text }}</option>
                                </select> -->

                    <!-- <ng-select2 [disabled]="ctrl.materias ? ctrl.materias.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.materias_id.value" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.materias_id);"
                                    [data]="ctrl.materias"></ng-select2> -->
                    <!-- <ng-select2 [disabled]="materias ? materias.length == 0 ? true : false : true" name="materias_id" formControlName="materias_id" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.materias_id.value" [data]="materias"></ng-select2> -->
                    <!-- </div>
                        </div>
                    </div> -->
                    <div class="columns">

                        <div class="column is-6">
                            <label class="label">Selecciona una carrera / plan: </label>
                            <div class="control has-icons-left has-icons-right">

                                <span class="icon is-small is-left">
                                    <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_periodo"></i>
                                </span>

                                <ng-select2
                                    [disabled]="ctrl.carreras_planes ? ctrl.carreras_planes.length == 0 ? true : false : true"
                                    [options]="ctrl.optionSelect" ([ngModel])="periodo_escolar"
                                    (valueChanged)="cargarDatos($event)" [data]="ctrl.carreras_planes"></ng-select2>
                            </div>
                        </div>
                        <!-- <div class="column is-4">
                            <label class="label">Costo:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('costo').hasError('required')}" placeholder="0.00" formControlName="costo">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('costo').hasError('required')">
                              <i class="fa fa-warning"></i>
                          </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('costo').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div> -->
                        <!-- <div class="column is-2">
                            <div class="field">
                                <br>
                                <div class="b-checkbox is-info" title="Si existen más costos para esta materia, y marca esta casilla, el resto de costos se desctivaran">
                                    <input id="activo" class="styled" [checked]="ctrl.dato.get('activo').value == '1' ? true : false" (change)="ctrl.dato.get('activo').patchValue(ctrl.dato.get('activo').value == '1' ? '0' : '1')" type="checkbox">
                                    <label for="activo">
                                  Activo o Vigente
                                </label>
                                </div>
                            </div>
                        </div> -->
                        <!-- <div class="column is-3">
                            <label class="label">HD:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" disabled readonly [ngClass]="{'is-danger': ctrl.dato.get('hd').hasError('required')}" placeholder="HD" formControlName="hd">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('hd').hasError('required')">
                              <i class="fa fa-warning"></i>
                          </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('hd').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div>
                        <div class="column is-3">
                            <label class="label">HI:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" disabled readonly [ngClass]="{'is-danger': ctrl.dato.get('hi').hasError('required')}" placeholder="HI" formControlName="hi">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('hi').hasError('required')">
                            <i class="fa fa-warning"></i>
                        </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('hi').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div>
                        <div class="column is-3">
                            <label class="label">Créditos:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" disabled readonly [ngClass]="{'is-danger': ctrl.dato.get('creditos').hasError('required')}" placeholder="Créditos" formControlName="creditos">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('creditos').hasError('required')">
                          <i class="fa fa-warning"></i>
                      </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('creditos').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div> -->
                    </div>

                    <div class="box" *ngIf="periodo_escolar">
                        <article class="media">
                            <div class="media-content">
                                <div class="content" style="overflow-y:auto;height: 70vh;">
                                    <table class="table is-striped is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>Clave</th>
                                                <th>Grado</th>
                                                <th>Materia</th>
                                                <th></th>
                                                <th>Costo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of periodo_escolar">
                                                <td> {{item.clave}} </td>
                                                <td> {{item.nivel}} </td>
                                                <td> {{item.nombre}} </td>
                                                <td>$</td>
                                                <td>
                                                   
                                                    <input class="input" type="number" min="0" [(ngModel)]="item.costo"
                                                        [ngModelOptions]="{standalone: true}">
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </article>
                    </div>
                </section>
            </form>
        </div>
    </div>
</div>

<div class="modal" id="confirmarCalificacion">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          <i class="fa fa-warning"></i> Alerta</p>
        <button class="delete" (click)="ctrl.cancelarModal('confirmarCalificacion')"></button>
      </header>
      <section class="modal-card-body">
        <div class="content">
          <h1>¿Esta seguro de guardar los cambios?</h1>
          <!-- <p>Esta acción podra afectar boletas impresas anteriormente</p> -->
        </div>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-success" (click)="enviar()" [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
        <a class="button" (click)="ctrl.cancelarModal('confirmarCalificacion')">Cerrar</a>
      </footer>
    </div>
  </div>